import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { NGB_OFFCANVAS, OdysseyOffcanvas } from './odyssey-offcanvas';

export function provideOdysseyOffcanvas() {
  return [
    { provide: NGB_OFFCANVAS, useClass: NgbOffcanvas },
    { provide: NgbOffcanvas, useExisting: OdysseyOffcanvas },
  ];
}
